








import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import DocumentHealthcarebanner from './DocumentHealthcarebanner';


import Itrequestform from './Itrequestform';
import Footer from './Footer';
import DocumentBfsitabone from './DocumentBfsitabone';
import AerospaceSecondVerticaltab from './AerospaceSecondVerticaltab';
import Dropdowndata from './Dropdowndata';
import DocumentManftabone from './DocumentManftabone';
import AerospaceDoceumentSEeconddata from './AerospaceDoceumentSEeconddata';
import Documentmanufctbanner  from './Documentmanufctbanner';
import DocumentBfsitwotab from './DocumentBfsitwotab';
import Documentmanufactsecnodtabs from './Documentmanufactsecnodtabs';

const Documnetmanufacturepage = () => {
  const location = useLocation();

  const firstContentRef = useRef(null); // Reference for the first content (DocumnetAutotabone)
  const secondContentRef = useRef(null); // Reference for the second content (DocumentAutotabtwo)

 useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  
  // Function to scroll to the first content dynamically
  const scrollToFirstContent = () => {
    if (firstContentRef.current) {
      const offset = 160;
      const elementPosition = firstContentRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };
  
  // Function to scroll to the second content dynamically
  const scrollToSecondContent = () => {
    if (secondContentRef.current) {
      const offset = 190;
      const elementPosition = secondContentRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  // The useEffect to handle hash-based scroll
  useEffect(() => {
    if (location.hash === "#documnetmanufacturepageSEeconddata") {
      setTimeout(() => {
        scrollToSecondContent();
      }, 500); // Delay ensures smooth scrolling after page load
    } else if (location.hash === "#documnetmanufacturepageone") {
      setTimeout(() => {
        scrollToFirstContent();
      }, 500); // Delay ensures smooth scrolling after page load
    }
  }, [location]); // Re-run when location (URL) changes

  return (
    <div style={{ background: '#fff' }}>
     <Documentmanufctbanner />

      <div ref={firstContentRef} id="documnetmanufacturepageone" className="margin-top-adjustment">
      <DocumentManftabone />
      </div>

      <div ref={secondContentRef} id="documnetmanufacturepageSEeconddata" className="margin-top-adjustment">
      <Documentmanufactsecnodtabs />
      </div>

      <br />
      <Itrequestform />

      <div className="page-footer" style={{marginTop:"-60px"}}>
        <Footer />
      </div>

      {/* <style>
        {`
          h1,h2,h3,h4,h5,h6,p {
            font-family: urbanist, serif;
          }
        `}
      </style> */}
      <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
    </div>
  );
}

export default Documnetmanufacturepage;

